// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_gT","advertCardNum":"c-a_gU"};